import React, { useState } from "react";
import SubmitButtonIcon from "../resources/svg/accept.svg";
// import { pages } from "../constants";
const SubmitButton = ({ onClick }) => {
  return (
    <img
      className="SubmitButtonSVG"
      src={SubmitButtonIcon}
      alt="SubmitButton"
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick();
      }}
    />
  );
};

export default SubmitButton;
